/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Field } from '@vtblife/uikit/dist/legacy';
import { createFormikComponent, mapFieldToInputProps } from '@vtblife/uikit-formik';
import { Checkbox, Input } from '@vtblife/uikit';
import styles from './formik-checkbox-group-field.module.css';
const CheckboxGroupFilteredProps = function (props) {
    // Skip some of params to be passed by Field to CheckboxGroup
    const { isValid, isError, errorMessage, fullWidth, label, note, hideNoteSpace, options, onChange, value: arrValues, ownAnswer, ...rest } = props;
    const getCheckboxOnChange = useCallback((value) => (_checked, event) => {
        if (onChange) {
            let newValues = arrValues;
            if (_checked && !arrValues.includes(value)) {
                newValues = [...arrValues, value];
            }
            else {
                newValues = arrValues.filter((val) => val !== value);
            }
            onChange(newValues, event);
        }
    }, [onChange, arrValues]);
    const items = options.map((option, i) => {
        return (React.createElement(CheckboxComponent, { ...rest, key: i, label: option.label, onChange: getCheckboxOnChange(option.value), value: arrValues.includes(option.value) }));
    });
    return (React.createElement("div", null,
        items,
        ownAnswer && (React.createElement(OwnAnswerCheckbox, { ...rest, key: 'ownAnswer', onTextChange: ({ currentValue: value, prevValue, event }) => {
                let newValues = arrValues.filter((val) => val !== prevValue);
                if (!arrValues.includes(value)) {
                    newValues = [...newValues, value];
                }
                else {
                    newValues = newValues.filter((val) => val !== value);
                }
                onChange(newValues, event);
            }, getCheckboxOnChange: getCheckboxOnChange, getActive: (text) => arrValues.includes(text) }))));
};
export function CheckboxComponent(props) {
    const { label, ...rest } = props;
    return (React.createElement("div", { className: styles.checkboxItem }, React.createElement(Checkbox, {
        ...rest,
    }, React.createElement("div", { className: styles.label }, label))));
}
export function OwnAnswerCheckbox(props) {
    const { onTextChange, getCheckboxOnChange, getActive, ...rest } = props;
    const [text, setText] = useState(null);
    const isActive = getActive(text);
    const inputRef = useRef();
    useEffect(() => {
        var _a;
        if (isActive) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [isActive]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { key: 'ownAnswerCheckbox', className: styles.checkboxItem },
            React.createElement(CheckboxComponent, { ...rest, label: 'Свой вариант', onChange: getCheckboxOnChange(text), value: isActive })),
        isActive && (React.createElement("div", { key: 'ownAnswerText', className: styles.checkboxItem },
            React.createElement(Input, { min: 1, type: "text", onChange: (value, event) => {
                    const currentValue = value.toString();
                    onTextChange({ currentValue, prevValue: text, event });
                    setText(currentValue);
                }, value: text || '', size: "l", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442", inputRef: inputRef })))));
}
export const CheckboxGroupField = Field(CheckboxGroupFilteredProps, false, false);
export const FormikCheckboxGroupField = createFormikComponent(CheckboxGroupField, mapFieldToInputProps);
//# sourceMappingURL=formik-checkbox-group-field.js.map